export const GET_REQUEST_FLOWS = '/flows';
export const getRequestFlows = data => ({
  type: GET_REQUEST_FLOWS,
  payload: data
});

export const GET_REQUEST_FLOWS_SUCCESS = 'flows/success';
export const getRequestFlowsSuccess = data => ({
  type: GET_REQUEST_FLOWS_SUCCESS,
  payload: data
});

export const GET_REQUEST_FLOWS_FAILURE = 'flows/failure';
export const getRequestFlowsFailure = () => ({
  type: GET_REQUEST_FLOWS_FAILURE
});

export const GET_REQUEST_LIST = '/requests';
export const getRequestList = data => ({
  type: GET_REQUEST_LIST,
  payload: data
})

export const GET_REQUEST_LIST_SUCCESS = '/requests/success';
export const getRequestListSuccess = data => ({
  type: GET_REQUEST_LIST_SUCCESS,
  payload: data
})

export const GET_REQUEST_LIST_FAILURE = '/requests/failure';
export const getRequestListFailure = data => ({
  type: GET_REQUEST_LIST_FAILURE
})

export const GET_REQUEST_LIST_EMPTY = '/requests/empty';
export const getRequestListEmpty = data => ({
  type: GET_REQUEST_LIST_EMPTY
})


export const CANCEL_MY_REQUEST = '/requests/cancel/onload';
export const cancelMyRequest = data => ({
  type: CANCEL_MY_REQUEST,
  payload: data
})

export const CANCEL_MY_REQUEST_SUCCESS = '/requests/cancel/success';
export const cancelMyRequestSuccess = data => ({
  type: CANCEL_MY_REQUEST_SUCCESS,
  payload: data
})

export const CANCEL_MY_REQUEST_FAILURE = '/requests/cancel/failure';
export const cancelMyRequestFailure = error => ({
  type: CANCEL_MY_REQUEST_FAILURE,
   payload: error
})

export const APPROVE_REQUEST = '/requests/approve/onload';
export const approveRequest = data => ({
  type: APPROVE_REQUEST,
  payload: data
});

export const APPROVE_REQUEST_SUCCESS = '/requests/approve/success';
export const approveRequestSuccess = data => ({
  type: APPROVE_REQUEST_SUCCESS,
  payload: data
});

export const APPROVE_REQUEST_FAILURE = '/requests/approve/failure';
export const approveRequestFailure = error => ({
  type: APPROVE_REQUEST_FAILURE,
  payload: error
});

export const REJECT_REQUEST = '/requests/reject/onload';
export const rejectRequest = data => ({
  type: REJECT_REQUEST,
  payload: data
});

export const REJECT_REQUEST_SUCCESS = '/requests/reject/success';
export const rejectRequestSuccess = data => ({
  type: REJECT_REQUEST_SUCCESS,
  payload: data
});

export const REJECT_REQUEST_FAILURE = '/requests/reject/failure';
export const rejectRequestFailure = error => ({
  type: REJECT_REQUEST_FAILURE,
  payload: error
});

export const RESET_REQUEST_MESSAGE = 'reset/message';
export const resetRequestMessage = () => ({
  type: RESET_REQUEST_MESSAGE
});

export const GET_PENDING_REQUEST_LIST = '/requests/pending';
export const getPendingRequestList = data => ({
  type: GET_PENDING_REQUEST_LIST,
  payload: data
})

export const GET_PENDING_REQUEST_LIST_SUCCESS = '/requests/pending/success';
export const getPendingRequestListSuccess = data => ({
  type: GET_PENDING_REQUEST_LIST_SUCCESS,
  payload: data
})

export const GET_PENDING_REQUEST_LIST_FAILURE = '/requests/pending/failure';
export const getPendingRequestListFailure = data => ({
  type: GET_PENDING_REQUEST_LIST_FAILURE
})
